module.exports = __webpack_public_path__ + "static/media/steelPerf.22e3f8be.jpg";